module.exports = __webpack_public_path__ + "static/media/Presence.a010cc7a.svg";